import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import Rodal from 'rodal';
import './rodal.scss';

const CustomRodal = ({
  header,
  visible,
  onClose,
  children,
  style = null,
  headerStyle = null,
  className = null,
  showClose = true,
  onOpen = null
}) => {
  const prevVisibleRef = useRef(visible);

  useEffect(() => {
    // Only call onOpen when transitioning from hidden to visible
    if (visible && !prevVisibleRef.current && onOpen) {
      onOpen();
    }
    prevVisibleRef.current = visible;
  }, [visible]); // onOpen intentionally excluded to avoid infinite loops since it's recreated on every render

  // The Rodal modal element to be rendered
  // Ensure modal z-index is always higher than mask z-index
  const modalZIndex = style?.zIndex || 999999;
  const maskZIndex = modalZIndex - 1;

  const modalContent = (
    <Rodal
      visible={visible}
      onClose={onClose}
      animation={'slideUp'}
      showCloseButton={showClose}
      className={className}
      customStyles={{
        ...style,
        zIndex: modalZIndex,
        height: 'fit-content'
      }}
      customMaskStyles={{ zIndex: maskZIndex }}
    >
      {header && (
        <div className="header" style={headerStyle}>
          {header}
        </div>
      )}
      <div className="body">{children}</div>
    </Rodal>
  );

  // Render the modal at the top of the DOM using a Portal
  return ReactDOM.createPortal(modalContent, document.body);
};

export { CustomRodal as Rodal };
